import { Badge, Button, Col, Row } from 'react-bootstrap';
import React, { useEffect, useState } from 'react';

import ModalAlert from '../Modal/ModalAlert';
import ModalConfiguration from '../Modal/ModalConfiguration';
import ModalDiaryHistory from '../Modal/ModalDiaryHistory';
import { isNotify } from '../../pages/Attribute/AttributeSlice';
import { toast } from 'react-toastify';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import {
  currentTime,
  disconnectThreshold,
} from '../../pages/Dashboard/Dashboard';

const FooterBar = ({
  setModeState,
  modeState,
  sendRpc,
  powerState,
  deviceId,
  isEdit,
  isDraw,
  setPowerState,
  setNewAlert,
  newAlert,
  timeTransfer1,
  setTimeTransfer1,
  curTimeTransfer1,
  timeTransfer2,
  setTimeTransfer2,
  curTimeTransfer2,
  timeTransfer3,
  setTimeTransfer3,
  curTimeTransfer3,
  sendFail,
  setSendFail,
  lastDisconnectTime,
  lastConnectTime,
  lastActivityTime,
  deviceName,
  runningOperation,
  setNotify,
  notify,
  isPower,
  isConfig,
  isMode,
  data,
  dataDiagram,
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [diaryModal, setDiaryModal] = useState(false);
  const [alertModal, setAlertModal] = useState(false);
  const [configModal, setConfigModal] = useState(false);

  useEffect(() => {
    dispatch(isNotify(notify));
  }, [notify]);

  const togglePower = () => {
    if (
      // lastDisconnectTime > lastConnectTime
      currentTime - lastActivityTime >
      disconnectThreshold
    ) {
      toast.error(`Your device ${deviceName} is offline`);
    } else {
      setPowerState(!powerState);
      sendRpc('setPower', !powerState);
    }
  };

  const toggleMode = () => {
    if (
      // lastDisconnectTime > lastConnectTime
      currentTime - lastActivityTime >
      disconnectThreshold
      ) {
      toast.error(`Your device ${deviceName} is offline`);
    } else {
      sendRpc('setMode', !modeState);
      setModeState(!modeState);
    }
  };

  return (
    <div>
      <Row>
        <Col lg={5}>
          <Button
            variant="outline-dark"
            size="lg"
            className="footbar__btn rounded-0 text-uppercase "
            onClick={() => setDiaryModal(true)}
            disabled={isEdit || isDraw}
          >
            {t('diary')}{' '}
          </Button>
          <Button
            variant="outline-dark"
            size="lg"
            className="footbar__btn rounded-0 text-uppercase border-left-0"
            onClick={() => {
              setNotify({ ...notify, unread: 0 });
              setAlertModal(true);
            }}
            disabled={isEdit || isDraw}
          >
            {t('alert')}
            <Badge pill bg="danger" text="light" style={{ marginLeft: '8px' }}>
              {notify?.unread === 0 || alertModal ? '' : notify?.unread}
            </Badge>
          </Button>
          <Button
            variant="outline-dark"
            size="lg"
            className={
              isEdit || isDraw || !isConfig
                ? 'footbar__btn rounded-0 text-uppercase border-left-0 disabled'
                : 'footbar__btn rounded-0 text-uppercase border-left-0'
            }
            onClick={() => setConfigModal(true)}
            disabled={isEdit || isDraw || !isConfig}
          >
            {t('customize')}
          </Button>
        </Col>
        <Col lg={1} />
        <Col className="flex-between">
          <div
            onClick={isPower ? togglePower : null}
            className={
              isPower
                ? powerState
                  ? 'wrapperActive'
                  : 'wrapper'
                : 'wrapperDisable'
            }
          >
            <div
              className={
                isPower
                  ? powerState
                    ? 'innerActive'
                    : 'inner'
                  : 'innerDisable'
              }
            >
              <span className="fa fa-power-off"></span>
            </div>
          </div>
          <div>{runningOperation}</div>
          <Button
            variant={modeState ? 'success' : 'danger'}
            size="lg"
            className={
              !powerState || isEdit || isDraw || !isMode
                ? 'rounded-0 text-uppercase m-0 disabled'
                : 'rounded-0 text-uppercase m-0'
            }
            onClick={toggleMode}
            disabled={!powerState || isEdit || isDraw || !isMode}
          >
            {modeState ? t('auto') : t('manual')}
          </Button>
        </Col>
      </Row>
      <ModalDiaryHistory
        show={diaryModal}
        setShow={setDiaryModal}
        deviceId={deviceId}
        dataDiagram={dataDiagram}
      />
      <ModalAlert
        show={alertModal}
        setShow={setAlertModal}
        newAlert={newAlert}
        setNewAlert={setNewAlert}
        deviceId={deviceId}
        notify={notify}
        setNotify={setNotify}
      />
      <ModalConfiguration
        show={configModal}
        setShow={setConfigModal}
        sendRpc={sendRpc}
        timeTransfer1={timeTransfer1}
        setTimeTransfer1={setTimeTransfer1}
        curTimeTransfer1={curTimeTransfer1}
        timeTransfer2={timeTransfer2}
        setTimeTransfer2={setTimeTransfer2}
        curTimeTransfer2={curTimeTransfer2}
        timeTransfer3={timeTransfer3}
        setTimeTransfer3={setTimeTransfer3}
        curTimeTransfer3={curTimeTransfer3}
        sendFail={sendFail}
        setSendFail={setSendFail}
        data={data}
      />
    </div>
  );
};

export default FooterBar;
